import { isNull } from '~/misc/Utils'
import { isUndefined } from 'lodash'
import axios from 'axios'

export default class Reviews {
    constructor() {
        this.section = document.querySelector('.amazon-reviews')
        this.init()
    }

    init() {
        if (isNull(this.section)) {
            return
        }

        this.fetchReviews()
    }

    fetchReviews() {
        axios.get('https://api.reviews.io/merchant/reviews?store=www.timbashield.co.uk').then((response) => {
            this.reviews = response.data
            this.validateReviews()
        })
    }

    validateReviews() {
        if (isUndefined(this.reviews) || this.reviews.stats.total_reviews === 0) {
            this.section.remove()
        }
    }
}